import { client } from "api";

export type AssignCompanyRequest = { orderId: string; companyId: string };
export type AssignCompanyResponse = void;

export const assignCompany = ({ orderId, companyId }: AssignCompanyRequest) =>
  client
    .post<AssignCompanyResponse>(`/order/${orderId}/companies/${companyId}`)
    .then((res) => res.data);
